export const environment = {
  production: false,
  whatsappNumber: '919338497282', // Country code + number, no plus
  geminiApiKey: 'AIzaSyDCVUkaeH4RXYQXcIXdgPMl89AHE7mQq4c', // Get free key from https://aistudio.google.com/apikey
  firebase: {
    apiKey: 'AIzaSyB8F4JF61jy8w9ceXrF8pdTbr9x2XR6gng',
    authDomain: 'my-project-c2a52.firebaseapp.com',
    projectId: 'my-project-c2a52',
    appId: '1:307690038304:web:5123ff78950de27359c845',
    storageBucket: 'my-project-c2a52.firebasestorage.app',
    messagingSenderId: '307690038304',
    measurementId: 'G-KJQQDJDYTC',
    databaseURL: 'https://my-project-c2a52-default-rtdb.firebaseio.com'
  }
};
